// GoogleLoginButton.js
import { useGoogleLogin } from "@react-oauth/google";
import { FaGoogle } from "react-icons/fa";

const GoogleLoginButton = ({ handleLogin }) => {
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => handleLogin(codeResponse),
    onError: (error) => console.log('Google Login Failed:', error)
  });

  return (
    <button
      type="button"
      onClick={() => login()}
      className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-500/20 transition-all duration-200 shadow-sm"
      title="Continue with Google"
    >
      <FaGoogle size={18} />
    </button>
  );
};

export default GoogleLoginButton;
